// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4a870117","885":"6e183994"}[chunkId] + ".chunk.js";
};